module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-24-d27f7dd510b2bc0d2c62778d2cc57da7.png";